import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import Table from "../common/Table";
import Button from "../common/Button";
import { clientService } from "../../services/clients";
import { exportToCsv } from "../../utils/exportCsv";
import { Download } from "lucide-react";

const ClientList = ({ filters, onEdit, onDelete }) => {
  const navigate = useNavigate();
  const { data: clients, isLoading } = useQuery({
    queryKey: ["clients", filters],
    queryFn: () => clientService.getAll(filters),
  });

  const columns = [
    { header: "Name", accessor: "name" },
    { header: "Phone", accessor: "phone" },
    { header: "Email", accessor: "email" },
    { header: "Company", accessor: "company" },
    { header: "Payment Status", accessor: "paymentStatus" },
  ];

  const actions = (row) => (
    <>
      <Button
        variant="secondary"
        className="mr-2"
        onClick={() => navigate(`/clients/${row._id}`)}
      >
        View
      </Button>
      <Button
        variant="secondary"
        className="mr-2"
        onClick={() => onEdit(row)}
      >
        Edit
      </Button>
      <Button
        variant="danger"
        onClick={() => onDelete(row._id)}
      >
        Delete
      </Button>
    </>
  );

  if (isLoading) return <div>Loading...</div>;

  return (
    <div>
      <div className="flex justify-end mb-3">
        <button
          onClick={() => exportToCsv("clients", clients, columns)}
          className="flex items-center gap-1.5 px-3 py-1.5 text-sm text-gray-600 hover:text-gray-800 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
        >
          <Download className="w-4 h-4" />
          Export CSV
        </button>
      </div>
      <Table columns={columns} data={clients} actions={actions} />
    </div>
  );
};

export default ClientList;
